import { toggleSidebar, showMessageWithTimeout, dismissMessageBar } from "../actions/app";
import { fetchStatOptions } from "../actions/stats_options";
import App from "./app";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { showModal, hideModal } from "../actions/modal";
import AppErrorBoundary from "./app_error_boundary";
import React from "react";

function mapStateToProps(state) {
  return {
    title: state.app.title,
    sidebarOpen: state.app.sidebarOpen,
    user: state.user.user,
    message: state.app.message,
    messageUUID: state.app.messageUUID,
    messageType: state.app.messageType,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleSidebar: () => {
      dispatch(toggleSidebar());
    },
    showMessageWithTimeout: (message, messageType, timeout) => {
      dispatch(showMessageWithTimeout(message, messageType, timeout));
    },
    dismissMessageBar: messageUUID => {
      dispatch(dismissMessageBar(messageUUID));
    },
    showModal: (modalType, modalProps) => {
      dispatch(showModal(modalType, modalProps));
    },
    hideModal: () => {
      dispatch(hideModal());
    },
    fetchStatOptions: () => dispatch(fetchStatOptions()),
  };
}

const AppWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(App));

const AppWrapperWithError = props => {
  return (
    <AppErrorBoundary>
      <AppWrapper {...props} />
    </AppErrorBoundary>
  );
};

export default AppWrapperWithError;
